import { I18n } from 'i18n-js'

const availableLanguages = [
  { name: 'English', code: 'en' },
  { name: 'हिन्दी', code: 'hi' },
]

const i18n = new I18n()
i18n.enableFallback = true
i18n.defaultLocale = 'en'

export { availableLanguages, i18n }
